import { ReactNode } from 'react'

const SimpleModal2Content = ({ children }: { children: ReactNode }) => {
  return <div className='px-18 pb-11'>{children}</div>
}

export default SimpleModal2Content
